import { DecimalPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-sites-table-entities-per-state-cell-part',
  imports: [DecimalPipe, NgClass],
  templateUrl: './sites-table-entities-per-state-cell-part.component.html',
  styleUrl: './sites-table-entities-per-state-cell-part.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SitesTableEntitiesPerStateCellPartComponent {
  public count = input.required<number>();
  public bgColorClass = input.required<string>();
  public title = input<string>();
}
